import { useCallback } from "react";
import { useAsyncPaginatedData } from "../../../../hooks/useAsyncPaginatedData";
import { listTaxonomyGaps, reopenTaxonomyGap } from "../../../../lib/corpusApi";
import { useUrlFilters } from "../../../../lib/url_filters";
import { taxonomyGapFiltersSchema } from "./taxonomyGapFilters";

/** The gaps not yet filled, narrowed by the filters in the URL, and the action that needs no
 *  form: sending a gap back to the judge. */
export function useTaxonomyGaps() {
  const [filters, setFilters] = useUrlFilters(taxonomyGapFiltersSchema);
  const { status, kind } = filters;

  const { items, loading, error, pagination, refresh } = useAsyncPaginatedData(
    (offsetPage) =>
      listTaxonomyGaps({
        ...offsetPage,
        status: status === "all" ? undefined : status,
        kind: kind === "all" ? undefined : kind,
      }),
    { pageSize: 25, key: `${status}:${kind}` }
  );

  const reopen = useCallback(
    async (id: string) => {
      await reopenTaxonomyGap(id);
      await refresh();
    },
    [refresh]
  );

  return { gaps: items, loading, error, pagination, filters, setFilters, refresh, reopen };
}
